module.exports = __webpack_public_path__ + "img/app_code2.eb13f0b1.png";